import React from 'react';

interface FormProps {
  formData: any;
  onChange: (id: string, value: string) => void;
}

export const LawyerIntake: React.FC<FormProps> = ({ formData, onChange }) => {
  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-1.5">
        <label className="text-sm font-medium text-gray-700">City and State</label>
        <input 
          type="text" 
          placeholder="E.g., Mumbai, Maharashtra" 
          value={formData.location || ''} 
          onChange={(e) => onChange('location', e.target.value)}
          className="w-full px-3 py-2 border border-gray-200 rounded-lg outline-none focus:ring-2 focus:ring-blue-500 text-sm" 
        />
      </div>
      <div className="flex flex-col gap-1.5">
        <label className="text-sm font-medium text-gray-700">Brief Details of your situation</label>
        <textarea 
          rows={4} 
          placeholder="Summarize your situation..." 
          value={formData.description || ''} 
          onChange={(e) => onChange('description', e.target.value)}
          className="w-full px-3 py-2 border border-gray-200 rounded-lg outline-none focus:ring-2 focus:ring-blue-500 text-sm resize-none" 
        />
      </div>
    </div>
  );
};